module.exports = __webpack_public_path__ + "img/board-front.0787c427.png";